import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";

import { TGoogleAnalytic, TStatusBar, Util } from "../../../app/util";

import { CONFIG } from "../../../app/config";
import {
    ENUM,
    TAction,
    TProdutoTipo,
    TCheckinFlague,
    TProfileTeam,
    TCentralLido,
    TCentralTipo,
} from "../../../app/enum";
import { DomSanitizer } from "@angular/platform-browser";
import { LogadoService } from "../../../providers/logado-service";
import { ProfileService } from "../../../providers/profile-service";
import { PushService } from "../../../providers/push-service";

import { ProfilePagePage } from "../profile-page/profile-page";
import { DevelopMenuPage } from "../develop-menu/develop-menu";
import { VisitorMenuPage } from "../visitor-menu/visitor-menu";
import { ContatoMenuPage } from "../contato-menu/contato-menu";
import { ChavecoMenuPage } from "../chaveco-menu/chaveco-menu";
import { PaybookMenuPage } from "../paybook-menu/paybook-menu";
import { VoucherInfoPage } from "../voucher-info/voucher-info";
import { MeritumMenuPage } from "../meritum-menu/meritum-menu";
import { SpotdayInfoPage } from "../spotday-info/spotday-info";
import { SupportMenuPage } from "../support-menu/support-menu";

@Component({
    selector: "page-central-menu",
    templateUrl: "central-menu.html",
    providers: [ProfileService, PushService],
})
export class CentralMenuPage {
    TCentralLido: any = TCentralLido;

    ENUM: any = ENUM;
    config: any;

    logado: any;

    page1: any;
    page2: any;
    page3: any;
    etapa: number;

    rootile: any;
    notifyes: any;

    manager: boolean;
    limitPage: number;

    constructor(
        public util: Util,
        public navCtrl: NavController,
        public navParams: NavParams,
        public sanitizer: DomSanitizer,
        public logadoService: LogadoService,
        public profileService: ProfileService,
        public pushService: PushService
    ) {
        this.config = CONFIG;

        this.etapa = this.navParams.get("etapa");
        this.rootile = this.navParams.get("rootile");
        this.logado = this.logadoService.getAuth();

        this.manager = this.logado.Profile.ProfileTeam == TProfileTeam.mkManager;
        this.limitPage = 0;

        /* Google Analytics */
        if (this.etapa == 0) this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Central', '/central-menu');

        this.page1 = DevelopMenuPage;
        this.page2 = CentralMenuPage;
        this.page3 = VisitorMenuPage;
        if (this.etapa == 1) this.centralLoad();
    }

    ionViewDidEnter() {
        this.util.statusBarColor(TStatusBar.sbStyleLightContent);
    }

    getTitle() {
        return "Central de Notificações";
    }

    onTabSelect(event) {

        //this.tabindex = event.index;

        //#Nao sei se funciona...
        //this.superTabsCtrl.showToolbar(false);

    }

    centralLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService
            .central(TAction.acLoad, '', this.rootile.Profile.ProfileID, 0, 0)
            .finally(() => loading.dismiss())
            .subscribe(
                (data) => this.centralRead(data),
                (erro) => this.util.alertResult(erro, () => this.dismiss())
            );
            
    }

    centralRead(data) {
        this.notifyes = data.Notifyes;
        
        // Notifye Read - Select Lido
        let count = 0;
        let reader = "";
        let unreads = this.notifyes.filter(notifye => (notifye.NotifyePush != TCentralLido.clRead));
        unreads.forEach(notifye => {
            count = count + 1;
            reader = reader + (reader == "" ? "" : ",") + notifye.NotifyeID;
        });

        // Notifye/Develop Read - Enviar Lido
        if (reader && this.logado.Profile.ProfileID == this.rootile.Profile.ProfileID) {
            this.profileService
                .central(TAction.acRead, reader, this.rootile.Profile.ProfileID, 0, this.limitPage)
                .subscribe(() => {
                    count = this.logado.Aboutme.NotifyeQtde - count;
                    if (count < 0) count = 0;

                    this.pushService.setBadge(count);
                    this.logadoService.notifyeQtds(count);
                });
        }
    }

    centralLine(line) {
        //if (line.NotifyeTipo == TCentralTipo.ctDevelop) this.developMenu(line);
        if (line.NotifyeTipo == TCentralTipo.ctSupport) this.supportMenu(line);
        if (line.NotifyeTipo == TCentralTipo.ctProfile) this.contatoMenu(line);
        if (line.NotifyeTipo == TCentralTipo.ctFriendy) this.profilePage(line);
        if (line.NotifyeTipo == TCentralTipo.ctVisitor) this.profilePage(line);
        if (line.NotifyeTipo == TCentralTipo.ctChaveco) this.chavecoMenu(line);
        if (line.NotifyeTipo == TCentralTipo.ctHotspot) this.spotdayMenu(line);
        if (line.NotifyeTipo == TCentralTipo.ctCheckin &&
            line.NotifyeFlag == TCheckinFlague.chCheckinEnter) this.navCtrl.parent.select(1); //Payout
        if (line.NotifyeTipo == TCentralTipo.ctCheckin &&
            line.NotifyeFlag == TCheckinFlague.chCheckinSaida) this.PaybookBora(line);
        if (line.NotifyeTipo == TCentralTipo.ctCheckin &&
            line.NotifyeFlag == TCheckinFlague.chCheckinAmigo) this.paybookMenu(line);
        if (line.NotifyeTipo == TCentralTipo.ctVoucher) this.voucherMenu(line);
        if (line.NotifyeTipo == TCentralTipo.ctParcela) {
        } //Open ParcelaOpen: line.ParcelaID;
        if (line.NotifyeTipo == TCentralTipo.ctPayment) {
        } //Open PaybookFind: line.PaymentAuth;
        if (line.NotifyeTipo == TCentralTipo.ctGatewey) {
        } //Open vendas... object = {profileID: 0, hotspotID: line.HotspotID, gatewayData: line.NotifyeData};
        if (line.NotifyeTipo == TCentralTipo.ctCard ||
            line.NotifyeTipo == TCentralTipo.ctSeal) this.meritumOpen(line);
    }

    profilePage(line) {
        let object = { profileID: line.Profile.ProfileID };
        this.util.navActive(this.navCtrl).push(ProfilePagePage, object);
    }

    chavecoMenu(line) {
        let object = { etapa: 0, profile: line.Profile, chaveco: line.Chaveco };
        this.navCtrl.push(ChavecoMenuPage, object, { animate: false });
    }

    voucherMenu(line) {
        let object = {etapa: 1, voucherID: line.VoucherID, profileID: 0, hotspotID: 0, notifyeID: line.NotifyeID};
        this.util.modalopen(VoucherInfoPage, 'alto', false, object).subscribe();
    }

    meritumOpen(line) {
        let meritum = { MeritumID: line.MeritumID };
        let object = {etapa: 4, rootile: null, meritums: [meritum], produtoTipo: TProdutoTipo.ptCard, copytums: null, textfind: this.rootile.Profile.ProfileID};
        this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe();
    }

    paybookMenu(line) {
        let object = {etapa: 0, olhaapp: true, fronter: true, profile: null, branded: null, userset: null, paybookID: line.PaybookID, paybook: null};
        this.util.modalopen(PaybookMenuPage, 'alto', false, object).subscribe();
    }

    PaybookBora(line) {
        //EntrakiOpenPage
    }

    spotdayMenu(line) {
        let object = {etapa: 0, spotdayID: line.SpotdayID};
        this.util.modalopen(SpotdayInfoPage, 'alto', false, object).subscribe();
    }

    contatoMenu(line) {
        let object = { etapa: 0, rootile: this.logado, contato: null };
        this.util.modalopen(ContatoMenuPage, 'alto', false, object).subscribe();
    }

    supportMenu(line) {
        let support = {SupportID: line.SupportID};
        let object = {etapa: 1, profile: null, supports: [support], selected: 0};
        this.navCtrl.push(SupportMenuPage, object);
    }

    dismiss() {
        this.navCtrl.pop();
        this.util.statusBarColor(TStatusBar.sbStyleDefault);
    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/central-menu/central-menu.ts